// extracted by mini-css-extract-plugin
export default {"panoramaContainer":"panoramaContainer___1X-ov","panorama":"panorama___248Tg"};